var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"timeline-on-grey",attrs:{"fluid":"","px-4":"","ma-0":""}},[_c('CaseConfigHeader',{attrs:{"header":"My Activity","subheader":"A timeline of all your interactions with data in Caseblocks."}}),_c('Loading',{attrs:{"isLoading":_vm.isCurrentUserLoading}},[_c('UserEvents')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }